<template>
  <div class="client" v-if="client">
    <el-container>
      <el-header height="100px" class="with-tags">
        <el-button class="header-btn pull-right"
                   type="primary"
                   icon="el-icon-circle-plus"
                   @click="createProject">Create New Project</el-button>
        <div class="search-bar pull-right">
          <el-input placeholder="Search..." v-model="searchTerm" />
        </div>
        <client-code v-if="!client.icon" :code="client.code" :seed="client.name" />
        <img v-if="client.icon" :src="client.icon_url" class="client-code"/>
        <h2 class="card-title" @click="editClient">{{ client.name }} <i class="el-icon-edit-outline"></i></h2>
        <project-filters :show-client-name="false"/>
        <div class="tags">
          <el-tag type="success" size="small"><icon name="regular/clock" /> {{ secondsToTime(client.total_time) }}</el-tag>
          <el-tag size="small" v-if="client.email"><icon name="envelope" /> {{ client.email }}</el-tag>
          <el-tag type="danger" size="small" v-if="client.phone"><icon name="mobile-alt" /> {{ client.phone }}</el-tag>
          <el-tag type="warning" size="small"><icon name="lightbulb" /> {{ clientCreatedDateString }}</el-tag>
          <el-tag size="small" :type="(client.prospect) ? 'info' : 'success'">{{ (client.prospect) ? 'Onboarding' : 'Client' }}</el-tag>
          <el-tag size="small" v-if="client.archived" type="danger">Archived</el-tag>
        </div>
      </el-header>
      <project-list :projects="clientProjects" :search-term="searchTerm" />
    </el-container>
    <client-crud :client="client"
                 v-if="showClientCrud"
                 :isProspect="this.$route.name === 'prospect'"
                 @close="clientCrudClose" />

    <project-crud v-if="showProjectCrud"
                  :clientId="client.id"
                  @close="projectCrudClose" />
  </div>
</template>

<script>
  import moment from 'moment'
  import { mixin as LogTimes } from '../../mixins/LogTimes'
  export default {
    name: 'client',
    mixins: [LogTimes],
    data () {
      return {
        client: null,
        showClientCrud: false,
        showProjectCrud: false,
        searchTerm: ''
      }
    },
    methods: {
      editClient () {
        this.showClientCrud = true
      },
      createProject () {
        this.showProjectCrud = true
      },
      handleRouteParamClientId () {
        this.client = this.clients[this.routeParamClientId]
        if (this.client) {
          this.$store.dispatch('getProjects', {client_id: this.client.id})
        }
      },
      clientCrudClose (client) {
        // Handle the Client Crud Dialog closing
        if (client) {
          this.$router.push({name: 'client', params: { client_id: client.id }})
        }
        this.showClientCrud = false
      },
      projectCrudClose (project) {
        // Handle the Project Crud Dialog closing
        this.showProjectCrud = false
        if (project) {
          // Just in case it's a new project, the above won't really do anything, ask the router to redirect if so
          this.$router.push({name: 'project', params: { project_id: project.id }})
        }
      },
      setPageTitle () {
        if (this.client) {
          this.$store.dispatch('setPageTitle', 'Clients')
        }
      }
    },
    computed: {
      currentUser () {
        return this.$store.state.users.currentUser
      },
      // All projects directly related to this client (for the project list)
      clientProjects () {
        var projects = []
        if (this.client) {
          for (var key in this.projects) {
            if (this.projects[key].client_id === this.client.id) {
              projects.push(this.projects[key])
            }
          }
        }
        return projects.sort((a, b) => {
          return a.id > b.id ? 0 : 1
        })
      },

      updatedClient () {
        return this.$store.state.clients.updatedObject
      },

      // Vuex Mappings
      users () {
        return this.$store.state.users.objects
      },
      clients () {
        return this.$store.state.clients.objects
      },
      projects () {
        return this.$store.state.projects.objects
      },
      tasks () {
        return this.$store.state.tasks.objects
      },
      logs () {
        return this.$store.state.logs.objects
      },

      // Vue Router Params
      routeParamClientId () {
        return this.$route.params.client_id
      },

      clientCreatedDateString () {
        if (this.client.created_at == null) {
          return 'Created (unknown)'
        } else {
          return 'Created ' + moment.utc(this.client.created_at).local().format('D/M/YY')
        }
      }
    },
    created () {
      this.handleRouteParamClientId()
    },
    mounted () {
      this.$store.dispatch('setPageTitle', 'Clients')
      setTimeout(() => {
        this.$store.dispatch('getClient', this.routeParamClientId)
      })
    },
    watch: {
      // When the route is programatically changed (e.g. when a different project is selected)
      // the route 'client_id' param (this.clientId) will change.
      // Re-init the Component's data when this happens
      'client' () {
        this.setPageTitle()
        this.handleRouteParamClientId()
      },
      // During Component creation, and after a new Client is added, the Vuex client list
      // will change. Watch for this change and update the Component's data when it happens
      'clients' () {
        this.handleRouteParamClientId()
      },
      'updatedClient' () {
        this.handleRouteParamClientId()
      },
      // If a user manually changes the route, force update the Component's data
      '$route' () {
        this.handleRouteParamClientId()
      }
    }
  }
</script>
<style lang="less" scoped>
  .card-title {
    cursor: pointer;
  }
</style>
